// Admittance
import { AdmittanceType } from '../enums/admittance-type.enum';
import { generateOption } from '../helpers/generate-option.helper';

export const admittanceTypeMap: Record<AdmittanceType, string> = {
  [AdmittanceType.Undefined]: 'Undefined',
  [AdmittanceType.Approved]: 'Approved',
  [AdmittanceType.TurnBack]: 'Turned back',
  [AdmittanceType.Readmission]: 'Readmission',
  [AdmittanceType.Credential]: 'Credential',
  [AdmittanceType.CredentialDenied]: 'Credential denied',
  [AdmittanceType.PlateScan]: 'PlateScan',
  [AdmittanceType.Welcome]: 'Welcome',
  [AdmittanceType.WelcomeDenied]: 'Welcome Denied',
  [AdmittanceType.Unidentified]: 'Unidentified',
  [AdmittanceType.Violation]: 'Violation',
  [AdmittanceType.Advisory]: 'Advisory',
};
export const admittanceOptions = generateOption(AdmittanceType, admittanceTypeMap);
export const admittanceColorMap: Record<AdmittanceType, string> = {
  [AdmittanceType.Undefined]: '#CCCCCC',
  [AdmittanceType.Approved]: '#C1FFEA',
  [AdmittanceType.TurnBack]: '#E1E5EA',
  [AdmittanceType.Readmission]: '#E1E5EA',
  [AdmittanceType.Credential]: '#C1FFEA',
  [AdmittanceType.CredentialDenied]: '#E1E5EA',
  [AdmittanceType.PlateScan]: '#C1FFEA',
  [AdmittanceType.Welcome]: '#C1FFEA',
  [AdmittanceType.WelcomeDenied]: '#E1E5EA',
  [AdmittanceType.Unidentified]: '#CCCCCC',
  [AdmittanceType.Violation]: '#FFA39E',
  [AdmittanceType.Advisory]: '#ed6615',
};

export const admittanceTagClassMap: Record<AdmittanceType, string> = {
  [AdmittanceType.Undefined]: '',
  [AdmittanceType.Approved]: '',
  [AdmittanceType.TurnBack]: '',
  [AdmittanceType.Readmission]: '',
  [AdmittanceType.Credential]: '',
  [AdmittanceType.CredentialDenied]: '',
  [AdmittanceType.PlateScan]: '',
  [AdmittanceType.Welcome]: '',
  [AdmittanceType.WelcomeDenied]: '',
  [AdmittanceType.Unidentified]: '',
  [AdmittanceType.Violation]: '',
  [AdmittanceType.Advisory]: 'white',
};
